import {
	DIRECTORY_GET_STATUS,
	DIRECTORY_GET_ERROR,

	DIRECTORIES_GET,
	DIRECTORY_GET,
	DIRECTORY_CLEAR
} from '@/store/directory/types'

const initialState = {
	loading: false,

	directories: [],
	directory: null,
	pageCount: {
		directories: 0,
	},
	errors: [],
}

export const state = { ...initialState }

export default {
	[DIRECTORY_GET_STATUS]: (state, status) => {
		state.loading = status
	},
	[DIRECTORY_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[DIRECTORIES_GET]: (state, payload) => {
		state.directories = [...payload.data]
		state.pageCount.directories = +payload.pageCount
	},
	[DIRECTORY_GET]: (state, payload) => {
		state.directory = payload
	},
	[DIRECTORY_CLEAR]: (state) => {
		state.directory = null
	}
}

